import { SUCCESS_CODE } from "./constants";

export interface IPostUrlSchemeLogParams {
  first_view_time: string;
  last_view_time: string;
  id: number;
  url: string;
  view_count: number;
}

// 小程序落地页埋点
export const postUrlSchemeLog = async (params: IPostUrlSchemeLogParams) => {
  try {
    const { errcode, errmsg } = await window.apis.postUrlSchemeLog(params);

    if (errcode !== SUCCESS_CODE) {
      throw Error(errmsg)
    }

  } catch (error) {
    console.log('error', error.message);
  }

};